import { createRoute, redirect } from '@tanstack/react-router'

import { PERMISSIONS } from '@forto-dev/auth-sdk-models'

import { getPermissionsFromToken, hasPermission } from '@/features/auth'
import { rootRoute } from '@/routes/root'
import { getCurrentToken } from '@/utils/auth'
import { ensureAuthenticatedUser, EnsureAuthenticatedUserProps } from '@/utils/auth-wall'

export const companyUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/users',
  beforeLoad: async (props: EnsureAuthenticatedUserProps) => {
    await ensureAuthenticatedUser(props)
    if (!hasPermission(getPermissionsFromToken(getCurrentToken()), PERMISSIONS.CUSTOMERS.USERS.READ)) {
      throw redirect({ to: '/' })
    }
  },
}).lazy(() => import('./users').then((d) => d.Route))
